var React = require('react');

function Puzzle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.423 10.711V4.463c0-.493-.4-.893-.893-.893h-6.248a3.57 3.57 0 00-7.141 0H.893C.4 3.57 0 3.97 0 4.463v6.375c.29-.08.59-.123.893-.127a3.57 3.57 0 110 7.141A3.518 3.518 0 010 17.725V24.1c0 .493.4.893.893.893h6.375c-.08-.29-.123-.59-.127-.893a3.57 3.57 0 117.14 0 3.518 3.518 0 01-.126.893h6.375c.493 0 .893-.4.893-.893v-6.248a3.57 3.57 0 100-7.14z","fill":"#000","fillRule":"nonzero"}));
}

Puzzle.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = Puzzle;

Puzzle.default = Puzzle;
